// Moved to the shared core with the phone's New category (docs/Mobile_Redesign_Plan.md, step 10).
export { parentChoices } from '@core/catalogue/forms';

/**
 * What happens to the photograph when the page is saved. The page holds the choice until Save so
 * a new category's picture can be chosen before the category exists — an IDENTITY key does not
 * exist until the insert has run, and the upload needs one.
 */
export type PhotoChange = { kind: 'keep' } | { kind: 'replace'; file: File } | { kind: 'remove' };

/**
 * The picture to show on the page: the one being added, nothing once removal is chosen, or the one
 * the category already has.
 */
export function shownPhoto(
  change: PhotoChange,
  stagedUrl: string | null,
  savedUrl: string | null,
): string | null {
  switch (change.kind) {
    case 'replace':
      return stagedUrl;
    case 'remove':
      return null;
    case 'keep':
      return savedUrl;
  }
}

/**
 * Photographs only, on the server's allow-list. Checked here so a clip is refused on the spot
 * rather than after the category has been saved without it.
 */
export const photoTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/heic'] as const;

export function isPhoto(file: { type: string }): boolean {
  return (photoTypes as readonly string[]).includes(file.type.toLowerCase());
}
